<template>
    <div class="feedback-wrapper">
        <div id="preloader" v-if="load" class="preloader"></div>
        <div class="rating-content">
            <div
                @click="goToArtist(artist.artist_slug)"
                class="artist-image-container"
                role="button"
            >
                <img :src="artist.artist_picture" />
                <div class="text-content">
                    <p class="artist-feedback">Artist Feedback</p>
                    <p class="artist-text">{{ artist.artist_name }}</p>
                </div>
            </div>
            <div v-if="width < 1000">
                <p class="feedback-container-title">
                    How did things go with {{ artist.artist_name }}?
                </p>
                <p
                    v-if="editFeedback"
                    class="edit-feedback"
                    @click="editArtistFeedback(artist.review_id)"
                >
                    Edit
                </p>
                <div v-if="!editFeedback" class="feedback-pills d-flex">
                    <p
                        v-for="(recomment, index) in allThings"
                        :key="index"
                        @click="getGeneralImpression(index)"
                        :class="{ 'selected-rate': selectedThings.includes(index) }"
                    >
                        {{ recomment }}
                    </p>
                </div>
                <div class="d-flex justify-content-start">
                    <p
                        v-if="editFeedback && artist.general_impression !== null"
                        class="selected-impression"
                    >
                        {{ allThings[artist.general_impression] }}
                    </p>
                </div>
            </div>
            <div>
                <div class="rating-details" :class="{ 'mb-0': editFeedback }">
                    <div class="d-flex align-items-center">
                        <p class="rating-details-text">Stage Presence</p>
                        <b-form-rating
                            v-model="stagePresence"
                            no-border
                            color="#ffffff"
                            :disabled="editFeedback"
                        >
                            <template #icon-full>
                                <img :src="URLS.icons.fullReviewStar" alt="star" />
                            </template>
                            <template #icon-empty>
                                <img :src="URLS.icons.emptyReviewStar" alt="emtpy-star" />
                            </template>
                        </b-form-rating>
                    </div>
                    <div class="d-flex align-items-center">
                        <p class="rating-details-text">Audience Engagement</p>
                        <b-form-rating
                            v-model="audienceEngagement"
                            no-border
                            color="#ffffff"
                            :disabled="editFeedback"
                        >
                            <template #icon-full>
                                <img :src="URLS.icons.fullReviewStar" alt="star" />
                            </template>
                            <template #icon-empty>
                                <img :src="URLS.icons.emptyReviewStar" alt="emtpy-star" />
                            </template>
                        </b-form-rating>
                    </div>
                    <div class="d-flex align-items-center">
                        <p class="rating-details-text">Communication</p>
                        <b-form-rating
                            v-model="communication"
                            no-border
                            color="#ffffff"
                            :disabled="editFeedback"
                        >
                            <template #icon-full>
                                <img :src="URLS.icons.fullReviewStar" alt="star" />
                            </template>
                            <template #icon-empty>
                                <img :src="URLS.icons.emptyReviewStar" alt="emtpy-star" />
                            </template>
                        </b-form-rating>
                    </div>
                    <div class="d-flex align-items-center">
                        <p class="rating-details-text">Timeliness</p>
                        <b-form-rating
                            v-model="timeliness"
                            no-border
                            color="#ffffff"
                            :disabled="editFeedback"
                        >
                            <template #icon-full>
                                <img :src="URLS.icons.fullReviewStar" alt="star" />
                            </template>
                            <template #icon-empty>
                                <img :src="URLS.icons.emptyReviewStar" alt="emtpy-star" />
                            </template>
                        </b-form-rating>
                    </div>
                    <div class="d-flex align-items-center">
                        <p class="rating-details-text">Overall Vibe</p>
                        <b-form-rating
                            v-model="overallVibe"
                            no-border
                            color="#ffffff"
                            :disabled="editFeedback"
                        >
                            <template #icon-full>
                                <img :src="URLS.icons.fullOverallStar" alt="star" />
                            </template>
                            <template #icon-empty>
                                <img :src="URLS.icons.emptyOverallStar" alt="emtpy-star" />
                            </template>
                        </b-form-rating>
                    </div>
                </div>
                <div class="artist-feedback-container" v-if="width < 1000">
                    <div class="input-content">
                        <div v-if="!editFeedback" class="d-flex justify-content-between">
                            <p class="input-content-top">What went well?</p>
                            <p class="input-content-top">{{ getFeedbackText }}/500</p>
                        </div>
                        <textarea
                            v-model="feedbackText"
                            type="text"
                            :disabled="getDisabledField"
                            placeholder="Share your feedback here…"
                        />
                    </div>
                </div>
                <button
                    v-if="!editFeedback && !updateFeedback"
                    class="submit-btn w-100"
                    :style="{ opacity: !feedbackText || disabledBtn ? 0.5 : 1 }"
                    :disabled="!feedbackText || disabledBtn"
                    @click="submitFeedback(artist.booking_id)"
                >
                    Submit Feedback
                </button>
                <button
                    v-if="updateFeedback"
                    class="submit-btn w-100"
                    :disabled="getDisabledField || disabledBtn"
                    :style="{ opacity: getDisabledField || disabledBtn ? 0.5 : 1 }"
                    @click="updateArtistFeedback"
                >
                    Update Feedback
                </button>
            </div>
        </div>
        <div class="artist-feedback-container" v-if="width > 1000">
            <div>
                <div class="d-flex justify-content-between">
                    <div>
                        <p v-if="editFeedback" class="feedback-container-title">
                            Thank you for your feedback!
                        </p>
                        <p class="feedback-container-title">
                            How did things go with {{ artist.artist_name }}?
                        </p>
                    </div>
                    <p
                        v-if="editFeedback"
                        class="edit-feedback"
                        @click="editArtistFeedback(artist.review_id)"
                    >
                        Edit
                    </p>
                </div>
                <div v-if="!editFeedback" class="feedback-pills d-flex">
                    <p
                        v-for="(recomment, index) in allThings"
                        :key="index"
                        @click="getGeneralImpression(index)"
                        :class="{ 'selected-rate': selectedThings.includes(index) }"
                    >
                        {{ recomment }}
                    </p>
                </div>
                <div class="d-flex justify-content-start">
                    <p
                        v-if="editFeedback && artist.general_impression !== null"
                        class="selected-impression"
                    >
                        {{ allThings[artist.general_impression] }}
                    </p>
                </div>
            </div>
            <div class="input-content">
                <div v-if="!editFeedback" class="d-flex justify-content-between">
                    <p class="input-content-top">What went well?</p>
                    <p class="input-content-top">{{ getFeedbackText }}/500</p>
                </div>
                <textarea
                    v-model="feedbackText"
                    type="text"
                    :disabled="getDisabledField"
                    placeholder="Share your feedback here…"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../../helpers/notification'
    import checkScreen from '../../../../mixins/check-screen'
    import disabledBtnValidation from '../../../../mixins/submit-button-validation'

    const URLS = {
        icons: {
            fullReviewStar: '/images/icons/star.svg',
            emptyReviewStar: '/images/icons/star-outline.svg',
            fullOverallStar: '/images/icons/overall-rating-filled.svg',
            emptyOverallStar: '/images/icons/overall-rating-empty.svg'
        }
    }
    export default {
        name: 'ArtistFeedbackCard',
        mixins: [checkScreen, disabledBtnValidation],
        props: {
            artist: {
                type: Object
            },
            counterOfferData: {
                type: Object
            }
        },
        data: () => ({
            load: false,
            feedbackText: '',
            stagePresence: '',
            audienceEngagement: '',
            communication: '',
            overallVibe: '',
            timeliness: '',
            generalImpression: '',
            allThings: ['Great!', 'Fine', 'Not so Good'],
            selectedThings: [],
            editFeedback: false,
            updateFeedback: false,
            reviewId: null
        }),
        methods: {
            goToArtist(slug) {
                if (!slug) return
                window.open('/artists/' + slug, '_blank')
            },
            editArtistFeedback(reviewId) {
                this.editFeedback = !this.editFeedback
                this.updateFeedback = !this.updateFeedback
                this.reviewId = reviewId
            },
            getGeneralImpression(index) {
                this.generalImpression = index
                if (this.selectedThings.includes(index)) {
                    const index = this.selectedThings.indexOf(index)
                    this.selectedThings.splice(index, 1)
                } else {
                    this.selectedThings.length = 0
                    this.selectedThings.push(index)
                }
            },
            async submitFeedback(bookingId) {
                this.disabledBtn = true
                try {
                    this.load = true
                    const response = await axios.post('/api/create/artist/' + bookingId, {
                        stage_presence: this.stagePresence,
                        audience_engagement: this.audienceEngagement,
                        communication: this.communication,
                        timeliness: this.timeliness,
                        overall_vibe: this.overallVibe,
                        general_impression: this.selectedThings.length
                            ? this.generalImpression
                            : '',
                        review: this.feedbackText
                    })
                    this.feedbackText = ''
                    this.stagePresence = ''
                    this.audienceEngagement = ''
                    this.communication = ''
                    this.timeliness = ''
                    this.overallVibe = ''
                    this.generalImpression = ''
                    notification('success', response.data.message)
                    window.location.reload()
                } catch (error) {
                    this.disabledBtn = false
                    notification('error', error.response.data.message)
                } finally {
                    this.load = false
                }
            },
            async updateArtistFeedback() {
                this.disabledBtn = true
                try {
                    this.load = true
                    const response = await axios.put('/api/update/artist/' + this.reviewId, {
                        stage_presence: this.stagePresence,
                        audience_engagement: this.audienceEngagement,
                        communication: this.communication,
                        timeliness: this.timeliness,
                        overall_vibe: this.overallVibe,
                        general_impression: this.selectedThings.length
                            ? this.generalImpression
                            : '',
                        review: this.feedbackText
                    })
                    notification('success', response.data.message)
                    window.location.reload()
                } catch (error) {
                    this.disabledBtn = false
                    notification('error', error.response.data.message)
                } finally {
                    this.load = false
                }
            },
            getFeedbackFields() {
                if (this.artist.stage_presence) this.stagePresence = this.artist.stage_presence
                if (this.artist.overall_vibe) this.overallVibe = this.artist.overall_vibe
                if (this.artist.general_impression !== null) {
                    this.generalImpression = this.artist.general_impression
                    this.selectedThings.push(this.artist.general_impression)
                }
                if (this.artist.timeliness) this.timeliness = this.artist.timeliness
                if (this.artist.communication) this.communication = this.artist.communication
                if (this.artist.audience_engagement)
                    this.audienceEngagement = this.artist.audience_engagement
                if (this.artist.review) {
                    this.feedbackText = this.artist.review
                    this.editFeedback = !!this.artist.review
                }
            }
        },
        computed: {
            getIcon() {
                return '/images/'
            },
            getFeedbackText() {
                return this.feedbackText.length
            },
            URLS: () => URLS,
            getDisabledField() {
                return !!(this.editFeedback && this.feedbackText.length)
            },
            ratingsValidated() {
                return !!(
                    this.stagePresence &&
                    this.audienceEngagement &&
                    this.communication &&
                    this.timeliness &&
                    this.overallVibe &&
                    this.feedbackText &&
                    this.selectedThings.length &&
                    this.selectedThings.every((item) => typeof item === 'number')
                )
            }
        },
        watch: {
            ratingsValidated: {
                handler: function (ratings) {
                    if (ratings) {
                        this.disabledBtn = false
                    } else {
                        this.disabledBtn = true
                    }
                },
                immediate: true
            }
        },
        created() {
            this.getFeedbackFields()
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .selected-impression {
        padding: 5px 40px 9px 40px;
        border-radius: 100px;
        background: #c9cd00;
        color: #000;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        letter-spacing: 0.14px;
    }
    .selected-rate {
        background: #d47ebf !important;
        color: #000000 !important;
    }
    .edit-feedback {
        color: #646464;
        text-align: right;
        font-feature-settings: 'dlig' on, 'ss10' on, 'ss05' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: 'Instrument Sans';
        font-size: 20px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        letter-spacing: -0.2px;
        cursor: pointer;
    }
    .venue-feedback {
        color: #d47ebf;
        font-feature-settings: 'dlig' on, 'ss05' on, 'ss10' on, 'ss07' on, 'ss08' on, 'ss03' on;
        font-family: Instrument Sans;
        font-size: 32px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .overall-rating {
        color: #acacac;
        font-family: 'Instrument Sans';
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
        flex: 0 1 50%;
        margin: 0;
    }
    .submit-btn {
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
        border-radius: 100px;
        background: #d188bf;
        padding: 11px 20px 12px 20px;
        margin-top: 14px;
        border: 0;
    }
    .form-control {
        background-color: #f8fafc00;
    }
    .rating-details-text {
        color: #acacac;
        font-size: 16px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 550;
        line-height: 125%;
        flex: 0 1 50%;
        margin: 0;
        text-wrap: nowrap;
    }
    .input-content textarea {
        width: 100%;
        padding: 12px 15px 15px;
        min-height: 235px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
        color: #acacac;
        font-family: 'Instrument Sans';
    }
    .input-content-top {
        color: #acacac;
        font-size: 12px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 650;
        line-height: 135%;
        letter-spacing: 0.12px;
    }
    .feedback-pills p {
        padding: 5px 20px 9px 20px;
        border-radius: 100px;
        border: 1px solid #d188bf;
        background: #262626;
        color: #d188bf;
        font-size: 14px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 600;
        line-height: 130%;
        letter-spacing: 0.14px;
        text-align: center;
        flex: 0 1 20%;
        margin-right: 10px;
        cursor: pointer;
        min-width: fit-content;
    }
    .feedback-pills {
        margin-bottom: 38px;
    }
    .feedback-container-title {
        color: #acacac;
        font-size: 22px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .rating-details {
        display: flex;
        flex-direction: column;
        margin-bottom: 50px;
    }
    .rating-details div {
        gap: 20px;
        margin-bottom: 20px;
    }
    .rating-content {
        flex: 0 1 30%;
    }
    .artist-feedback-container {
        display: flex;
        flex-direction: column;
        flex: 0 1 70%;
    }
    .some-details {
        color: #acacac;
        font-size: 22px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .feedback-wrapper {
        max-width: 1050px;
        display: flex;
        justify-content: space-between;
        border-radius: 15px;
        background: #262626;
        width: 100%;
        gap: 40px;
        padding: 25px;
        margin-bottom: 25px;
    }
    .artist-image-container {
        display: flex;
        gap: 15px;
        margin-bottom: 38px;
    }
    .text-content {
        display: flex;
        flex-direction: column;
    }
    .artist-text {
        color: #acacac;
        font-size: 32px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.64px;
    }
    .artist-feedback {
        color: #acacac;
        font-size: 22px;
        font-family: 'Instrument Sans';
        font-style: normal;
        font-weight: 500;
        line-height: 120%;
        letter-spacing: -0.22px;
    }
    .artist-image-container img {
        max-width: 75px;
        max-height: 75px;
        border-radius: 12px;
    }
    @media (max-width: 1000px) {
        .feedback-wrapper {
            display: block;
            background: transparent;
            padding: 16px;
        }
        .artist-feedback-container {
            flex: 0 1 100%;
        }
        .rating-content {
            flex: 0 1 100%;
        }
        .artist-text {
            text-overflow: ellipsis;
            overflow: hidden;
            max-width: 250px;
            white-space: nowrap;
        }
        .overall-rating {
            flex: 0 1 90%;
        }
        .rating-details {
            margin-bottom: 0;
        }
        .rating-details-text {
            flex: 0 1 80%;
            text-wrap: wrap;
        }
    }
</style>
